var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M23.46 16.862L17 23.322V6.334a1 1 0 10-2 0v16.988l-6.46-6.46a1 1 0 00-1.414 1.414l8.049 8.05a1.167 1.167 0 001.65 0l8.048-8.05a1 1 0 10-1.414-1.414z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }